module.exports = __webpack_public_path__ + "static/media/OccassionsGrey.cae8af6d.svg";